(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    //
    //

  function pxAdConfigNetwork(
    $http, $timeout, NetworkListPaging, NetworkListService, toastr, $filter
  ) {
    return {
      restrict: 'EA',
      scope: {
        context: '=context',
        tenant: '=resource',
        meta: '=meta',
        callback: '&callback'
      },
      templateUrl: 'app/components/authenticationSettings/activeDirectory/activeDirectoryNetwork/activeDirectoryNetwork.template.html',
      link: function(scope) {

        scope.paginationObject = new NetworkListPaging();
        var scrollEnd = null;
        var containerHeight = null;
        scope.searchString = '';
        scope.selectedSignInProfile = null;

        (function() {
          getFirstPage();
        })();

        ////////////////////////////////////
        ////////////////////////////////////
        //////  Pagination stuff
        ////////////////////////////////////
        function getFirstPage () {
          scope.paginationObject.pagingCriteria.pageSize = 10;
          scope.list = [];
          scope.loadingPage = true;
          NetworkListService.getNetworkListPaged(scope.paginationObject).then(function(printerSignInProfiles) {
            window.scrollTo(0,0);
            scope.loadingPage = false;
            scope.totalPages = printerSignInProfiles.page.totalPages;
            if (printerSignInProfiles.list) {
              scope.list = printerSignInProfiles.list;
            }
          }).catch(function(error) {});
        }

        scope.textSearch = function () {
          scope.paginationObject.pagingCriteria.match = scope.searchString;
          scope.list = [];
          $timeout(function () {
            getFirstPage();
          }, 500)
        }

        function getNextPage () {
          if (!scope.loadingPage && scope.totalPages > scope.paginationObject.pagingCriteria.page + 1) {
            scope.loadingPage = true;
            scope.paginationObject.pagingCriteria.page += 1;
            NetworkListService.getNetworkListPaged(scope.paginationObject).then(function(printerSignInProfiles){
              if (printerSignInProfiles.list) {
                scope.list = scope.list.concat(printerSignInProfiles.list);
              }
              scope.loadingPage = false;
            }).catch(function(error) {});
          }
        }

        angular.element('.item-list-nested').on('scroll', function (event) {
          scrollEnd = event.currentTarget.clientHeight + event.currentTarget.scrollTop + 1;
          containerHeight = event.currentTarget.scrollHeight;
          if (!scope.loadingPage && scope.totalPages > scope.paginationObject.pagingCriteria.page + 1) {
            if (scrollEnd > containerHeight) {
              $timeout(function() {
                getNextPage();
              }, 300)
            }
          }
        });

        scope.$on('$destroy', function() {
          angular.element('.item-list-nested').off('scroll');
        });


        ////////////////////////////////////
        ////////////////////////////////////
        //////  Select
        ////////////////////////////////////
        scope.selectItem = function (item) {
          scope.selectedItem = item;
        }

        scope.confirm = function () {
          scope.callback({item : scope.selectedItem});
        }

      }
    };
  }

  pxAdConfigNetwork.$inject = [
    '$http', '$timeout', 'NetworkListPaging', 'NetworkListService', 'toastr', '$filter'
  ];

  angular
    .module('printix-admin')
    .directive('pxAdConfigNetwork', pxAdConfigNetwork);

})();
